// eslint-disable-next-line
export const setNestedProperty = (obj: any, path: string | string[], value: any) => {
  if (Object(obj) !== obj) {
    return obj;
  }
  if (!Array.isArray(path)) {
    path = path.toString().match(/[^.[\]]+/g) || [];
  }
  path.forEach((key, index, array) => {
    if (index == path.length - 1) {
      obj[key] = value;
    } else {
      if (!obj.hasOwnProperty(key)) {
        const next = array[index + 1];
        obj[key] = String(Number(next)) === next ? [] : {};
      }
      obj = obj[key];
    }
  });
  return obj;
};

export const isString = (val): boolean => {
  return typeof val === 'string' || val instanceof String;
};

export const numRange = (min, max) => {
  return [...Array(max - min + 1).keys()].map((x) => x + min);
};

export const limitStr = (str, max = 2) => {
  return str.toString().substring(0, max);
};

export function groupArrayByKey<T>(data: T[], key: string): Record<string, T[]> {
  return data.reduce((acc, cur) => {
    acc[cur[key]] = acc[cur[key]] || []; // if the key is new, initiate its value to an array, otherwise keep its own array value
    acc[cur[key]].push(cur);
    return acc;
  }, {});
}

// returns true if any of the object properties have a value '' or 0
export const hasEmptyValues = (obj: {}) => {
  return Object.values(obj).some((value) => value === '' || value === 0);
};

export const isEmptyValue = (value): boolean => {
  return value === null || value === undefined || value === 0 || value === '' || Number.isNaN(value);
};

// return an new object that only contains the keys from obj that are specified by the keys param
// usage: pick({a: 1, b: 2, c: 3}, ['a', 'c']); output: {a: 1, c: 3}
export const pick = (obj: {}, keys: string[]) => {
  return Object.fromEntries(keys.filter((key1) => key1 in obj).map((key2) => [key2, obj[key2]]));
};

export const sleep = (delayMs: number) => new Promise((resolve) => setTimeout(resolve, delayMs));
